<template>
  <div class="wt-upload-asset">
    <div class="wt-asset-container">
      <wt-progress-native :value="progress" :max="100" />
      <div class="-label">Uploading<wt-ellipsis-animation /></div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
export default Vue.extend({
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      progress: null,
    };
  },

  created() {
    const model = app.UploadQueue.getVisualQue().find((model) => {
      return model.get('metadata').assetUUID === this.asset.metadata.assetUUID;
    });

    if (model) {
      model.on('change:progress', (uqm, progress) => {
        this.progress = progress.percentage;
      });
    }
  },
});
</script>
